import { ThunderboltOutlined } from '@ant-design/icons';
import { type NodeProps } from '@xyflow/react';
import LeadDistributionContent from 'automations/components/Nodes/LeadDistributionContent';
import { type DistributeLeadNodeType } from 'automations/types/nodeSchemas/actionNodes';
import { nodeSchemas } from 'automations/types/nodeTypes';
import { getErrorList } from 'automations/utils/zod';
import { useMemo } from 'react';

import { type ActionNodeReturnProps } from './useActionNodeConfig';

export default function useDistributeLead(node: NodeProps<DistributeLeadNodeType>): ActionNodeReturnProps {
  const errorMessages = useMemo(() => getErrorList(nodeSchemas.DistributeLeadActionNodeData, node.data), [node.data]);
  const AdditionalUI = useMemo(() => <LeadDistributionContent node={node} />, [node]);

  return {
    icon: ThunderboltOutlined,
    hasErrors: errorMessages.length > 0,
    errorMessages,
    AdditionalUI,
  };
}
